import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

export function useRolesState(): { roles: string[]; loaded: boolean } {
  const { instance, accounts } = useMsal();
  const [roles, setRoles] = useState<string[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const getRolesFromAccessToken = async () => {
      if (accounts.length > 0) {
        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });

          const accessToken = response.accessToken;
          const parsedJwt = JSON.parse(atob(accessToken.split(".")[1]));
          const rolesFromToken = parsedJwt.roles || [];

          setRoles(rolesFromToken);
        } catch (error) {
          console.error("Failed to extract roles", error);
        }
        setLoaded(true);
      }
    };

    getRolesFromAccessToken();
  }, [accounts, instance]);

  return { roles, loaded };
}

export function useRoles(): string[] {
  return useRolesState().roles;
}
